import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fs16 ls1 mc fw600 headerTitle" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "yokoso" }, " ようこそ、", -1)
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "yokoso" }, "へ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "fs14 fw600" }, "waaq Linkの使い方", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs13 greyColor",
  style: {"margin-bottom":"8px"}
}, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/tos",
    target: "_blank",
    class: "greyColor",
    style: {"text-decoration":"underline"}
  }, "利用規約"),
  /*#__PURE__*/_createTextVNode("に同意の上、日程調整を開始してください。 ")
], -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", {
  class: "posFi fs13 greyColor",
  style: {"bottom":"78px"}
}, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/tos",
    target: "_blank",
    class: "greyColor",
    style: {"text-decoration":"underline"}
  }, "利用規約"),
  /*#__PURE__*/_createTextVNode("に同意の上、日程調整を開始してください。 ")
], -1)
const _hoisted_16 = {
  class: "centered whiteColor fs18",
  style: {"line-height":"60px"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UsageContent = _resolveComponent("UsageContent")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("h3", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("img", {
        src: _ctx.$getAssetImageUrl(`/assets/logo/waaqLink_logo_flat.gif`),
        width: "200"
      }, null, 8, _hoisted_3),
      _hoisted_4
    ]),
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9,
    _createVNode(_component_UsageContent),
    _hoisted_10,
    _hoisted_11,
    (!_ctx.isSP)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("section", {
            class: "pointer centered circle_button skyblueBg agreeButton",
            onClickOnce: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.agreementAndConfirmInfo && _ctx.agreementAndConfirmInfo(...args)))
          }, _toDisplayString(_ctx.agreeTosButtonTitle), 33)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("section", {
            class: "posFi w100 skyblueBg fw600",
            style: {"bottom":"0","height":"60px","left":"0"},
            onClickOnce: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.agreementAndConfirmInfo && _ctx.agreementAndConfirmInfo(...args)))
          }, [
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.agreeTosButtonTitle), 1)
          ], 32)
        ])),
    _hoisted_17
  ]))
}